if (!customElements.get('winterset-gallery')) {
  customElements.define('winterset-gallery', class WintersetGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-winterset-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-winterset-thumb]')];
      this.index = 0;
      this.querySelectorAll('[data-winterset-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.wintersetThumb)));
      });
      this.querySelector('[data-winterset-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-winterset-next]')?.addEventListener('click', () => this.show(this.index + 1));
    }

    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      this.thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === this.index;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const count = this.querySelector('[data-winterset-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
  });
}
